<template>
  <div>
  </div>
</template>

<script>
export default {
  name: "AutoNotification"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/contents/main/notify/AutoNotification.vue